export default "__VITE_ASSET__CChSQx9F__"